/* eslint-disable import/extensions */
import React from 'react';

import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';

import { Spinner } from '@/components/Spinner/Spinner';
import { isTokenValid } from '@/utils/index';

const DisconnectedUser = ({ tokenName }: any) => {
  const { data: signer } = useAccount();
  return (
    <div className="">
      <div className=" ">
        <div className="flex items-center  mt-4">
          <div>
            <h4 className="font-semibold mr-1 w-16">Step 1 :</h4>
          </div>

          <p>{`Connect your wallet that has the token ${tokenName}`}</p>
        </div>
        <div className="mt-4">
          <ConnectButton.Custom>
            {({ openConnectModal }) => {
              return (
                <div className="flex items-center md:mr-0 justify-center">
                  {(() => {
                    const connecting =
                      signer?.address &&
                      typeof window !== 'undefined' &&
                      !isTokenValid(
                        localStorage.getItem('token'),
                        signer?.address
                      );

                    return (
                      <button
                        onClick={openConnectModal}
                        type="button"
                        className={`bg-black text-white rounded-lg px-10 py-2 text-lg`}
                      >
                        {connecting ? <Spinner /> : 'Connect'}
                      </button>
                    );
                  })()}
                </div>
              );
            }}
          </ConnectButton.Custom>
        </div>
      </div>
      <div className="flex">
        <div className="flex items-center  mt-4">
          <div>
            <h4 className="font-semibold mr-1 w-16">Step 2 :</h4>
          </div>

          <p>Enjoy the private file you have recieved</p>
        </div>
      </div>
    </div>
  );
};

export default DisconnectedUser;
